import React, { useState } from 'react';
import { Button } from '@general';
import { ConnectedDeviceSummary, DeviceSummary, DeviceType } from '@types';

import { DeviceItem } from '../deviceItem/DeviceItem';

import styles from './devicesList.module.scss';

export interface DevicesListProps {
	devices: DeviceSummary[];
	onItemClick: (device: DeviceSummary | ConnectedDeviceSummary) => void;
	selectedDevice: string;
	setShowFaulty: (bool: boolean) => void;
}

export const DevicesList = ({
	devices: devices,
	onItemClick,
	selectedDevice: selectedDeviceId,
	setShowFaulty,
}: DevicesListProps) => {
	// State
	const [LIST, MAP] = ['List', 'Map'];
	const [toggle, setToggle] = useState(LIST);
	const [showToggle] = useState(false);

	const handleToggleClick = (value: string) => {
		setToggle(value);
	};

	const createToggleBtn = (btnName: string) => {
		return (
			<Button
				customStyles={[
					styles['toggle-button'],
					toggle === btnName && styles['toggle-button-selected'],
				].join(' ')}
				onClick={() => {
					handleToggleClick(btnName);
				}}
			>
				{btnName}
			</Button>
		);
	};

	const connectedSensors = (device: DeviceSummary) => {
		const isModularMeter = device.type === DeviceType.type.MODULAR_METER;
		return (
			<>
				{isModularMeter &&
					(device.connectedDevices ?? [])
						.filter(connectedDevice => connectedDevice.type === ConnectedDeviceSummary.type.SENSOR)
						.map(connectedDevice => (
							<DeviceItem
								device={connectedDevice}
								key={connectedDevice.id}
								onItemClick={onItemClick}
								selected={selectedDeviceId === connectedDevice.id}
								isNested={true}
							/>
						))}
			</>
		);
	};

	return (
		<div className={styles.wrapper} data-testid="metersList">
			{showToggle && (
				<div className={styles.toggle} aria-label="toggle between list and map view">
					{createToggleBtn(LIST)}
					<div className={styles['toggle-border']} />
					{createToggleBtn(MAP)}
				</div>
			)}
			<div className={styles[`meter-list`]}>
				<table aria-label="meter list">
					<thead>
						<tr className={styles[`meter-list-header`]} aria-label="meter list - header">
							<th>Name</th>
							<th>Make model</th>
							<th>Status </th>
							<th>Last reading date </th>
							<th></th>
						</tr>
					</thead>
					<tbody data-testid="metersTableBody">
						{devices.map(device => (
							<React.Fragment key={device.id}>
								<DeviceItem
									device={device}
									onItemClick={onItemClick}
									selected={selectedDeviceId === device.id}
								/>
								{connectedSensors(device)}
							</React.Fragment>
						))}
					</tbody>
				</table>
			</div>
			<div className={styles['buttons-container']}>
				<Button
					ariaLabel="open report form"
					customStyles={styles.report}
					type="primary"
					size="large"
					onClick={() => {
						setShowFaulty(true);
					}}
				>
					Report faulty device
				</Button>
			</div>
		</div>
	);
};
